export default function ({ route, redirect, app }) {
    if(process.server) return;
    // Extract the requested locale from the URL
    const urlParts = route.fullPath.split('/');

    const requestedLocale = urlParts[1]; // Get the first index after splitting

    // Check if the requested locale is valid
    const isValidLocale = app.i18n.locales.some(locale => locale.code === requestedLocale);

    if (isValidLocale) {
        // Switch to the requested locale
        app.i18n.locale = requestedLocale;

        // Check if the URL ends with a slash but not with a query parameter
        if (urlParts.length <= 2 && !route.fullPath.includes('?')) {
            return redirect(`${route.fullPath}`);
        }
        return;
    }
    // Redirect to the route with the locale path added
    const currentLocale = app.i18n.localeProperties.code || 'fi-fi';
    const redirectTo = `/${currentLocale}${route.fullPath}`;
    return redirect(redirectTo);
}